// Sonar : une question posée au panel, son étude, ses étapes et sa note d'étude.
export default {
  sousTitre: {
    format: 'Une question sur un format, posée au panel : ce qu’il choisit, ce qu’il préfère, ce qu’il en dit',
    explorer: 'Une question ouverte, posée aux publics que vous choisissez : ce qu’ils choisissent, ce qu’ils préfèrent, ce qu’ils en disent',
  },
  // Les exemples d'Explorer ; le Sonar d'un dossier n'en a pas.
  exemples: {
    e1: 'Faut-il rendre les transports en commun gratuits ?',
    e2: 'Qui pour présenter la prochaine Star Academy ?',
    e3: 'Quel nom pour une nouvelle marque de yaourts bio ?',
    e4: 'Les Français sont-ils prêts à payer pour une information sans publicité ?',
  },
  erreur: {
    etudes: 'Études illisibles',
    question: 'Question refusée',
    etude: 'Étude illisible',
    modification: 'Modification non enregistrée',
    lancement: 'Lancement refusé',
  },
  mots: {
    choix: {
      pastille: 'Réponses à choisir',
      liste: 'Les réponses proposées au panel',
      ajout: 'Ajouter une réponse',
      compte: '{n} réponse | {n} réponse | {n} réponses',
      garder: 'Gardez au moins {nb} réponses.',
    },
    notation: {
      pastille: 'Liste à noter',
      liste: 'Ce que le panel notera, de 0 à 10',
      ajout: 'Ajouter un élément',
      compte: '{n} élément | {n} élément | {n} éléments',
      garder: 'Gardez au moins {nb} éléments.',
    },
    combinaison: {
      pastille: 'Combinaisons',
      liste: 'Les candidats proposés',
      ajout: 'Ajouter un nom',
      compte: '{n} candidat | {n} candidat | {n} candidats',
      garder: 'Gardez au moins {nb} candidats.',
    },
  },
  statut: {
    candidats_en_cours: 'En conception',
    elicitation_a_creer: 'Question ouverte en préparation',
    elicitation_protocole: 'Question ouverte en préparation',
    elicitation_en_cours: 'Le panel propose',
    candidats: 'À relire',
    notation_a_creer: 'Notation en préparation',
    notation_protocole: 'Notation en préparation',
    notation_en_cours: 'Le panel note',
    choix_a_creer: 'Tir en préparation',
    choix_protocole: 'Tir en préparation',
    choix_en_cours: 'Le panel répond',
    rendu: 'Rendu',
    echec: 'Arrêtée',
  },
  signal: {
    en_ligne: 'Monte en ligne',
    terrain: 'Vos publics en parlent',
    notoriete: 'Valeur sûre',
    panel: 'Proposé par le panel',
  },
  avancement: {
    nomsSansListe: 'Le panel propose ses propres noms, sans liste.',
    ideesSansListe: 'Le panel propose ses propres idées, sans liste.',
    panelARepondu: '{pct} du panel a répondu.',
    voteSuivra: 'La liste du vote suivra.',
    panelNote: 'Le panel note chaque élément, de 0 à 10.',
    departageSuivra: 'Le départage suivra de lui-même.',
    tirEnFile: 'Le tir attend sa place derrière les tirs du jour : il partira dès qu’une place se libère.',
    panelRepond: 'Le panel répond à la question.',
    departageEnFile: 'La notation est faite. Le départage des combinaisons attend sa place derrière les tirs du jour : il partira dès qu’une place se libère.',
    panelDepartage: 'Le panel départage les combinaisons, face à la dernière saison.',
    reponsesRecues: '{pct} des réponses reçues.',
  },
  deja: {
    role: 'Déjà {role}',
    jamaisRole: 'Jamais {role}',
    vu: 'Déjà vu',
    nouveau: 'Nouveau',
  },
  panneau: {
    ouverte: 'Ce que le panel recherche',
    vote: 'Ce que le panel en dit du vote',
    combinaison: 'Ce que le panel en dit de la combinaison',
  },
  liste: {
    poser: 'Posez votre question au panel',
    publics: 'Les publics interrogés',
    concevoir: 'Concevoir l’étude',
    jeRelis: 'Je relis avant le vote',
    vosQuestions: 'Vos questions',
    aucune: 'Pas encore de question posée.',
  },
  autonome: 'Autonome',
  chargement: 'Chargement…',
  combinaisonDe: 'de {nb} {roles}',
  poseePar: 'Posée par {nom}',
  archiver: 'Archiver',
  archiverConfirmer: 'Confirmer l’archivage',
  noteDEtude: 'Note d’étude',
  toutesLesQuestions: 'Toutes les questions',
  conception: {
    sujet: 'Orion se renseigne sur le sujet et choisit qui interroger.',
    sujetPublicsChoisis: 'Orion se renseigne sur le sujet.',
    etude: 'Orion conçoit l’étude.',
  },
  lecture: {
    territoire: 'Territoire',
    tranche: 'Tranche',
  },
  ensemble: 'Ensemble',
  titre: {
    explorer: 'Explorer',
    nomsSansListe: 'Les noms que le panel propose, sans liste',
    ideesSansListe: 'Ce que le panel propose, sans liste',
    recherche: 'Ce que le panel recherche',
    reponseDuPanel: 'Ce que répond le panel',
    voteCandidats: 'Le vote, candidat par candidat',
    voteElements: 'Le vote, élément par élément',
    enDit: 'Ce que le panel en dit',
    combinaisonGagnante: 'La combinaison gagnante',
    candidatGagnant: 'Le candidat gagnant',
  },
  nouveaux: {
    ecran: '{pct} {phrase}, {distincts} {differents}.',
    livrable: '{pct} {phrase} ; {distincts} {differents}.',
    personnes: 'du panel propose quelqu’un qui n’a jamais été {role}',
    personnesSansRole: 'du panel propose quelqu’un qui n’a jamais été dans ce rôle',
    idees: 'du panel propose quelque chose que le programme n’a jamais fait',
  },
  distincts: {
    personnes: 'noms différents',
    idees: 'réponses différentes',
  },
  dansLeVoteAria: 'Dans le vote',
  voirTous: {
    personnes: 'Voir les {nb} noms',
    idees: 'Voir les {nb} réponses',
  },
  legende: {
    ensemble: 'L’ensemble',
    dansLeVote: 'dans le vote',
  },
  interroger: {
    panel: 'Interroger le panel',
    reponse: 'Interroger ceux qui ont répondu « {option} »',
    ceuxQuiLaVeulent: 'Interroger ceux qui la veulent',
    jury: 'Interroger ceux qui auraient envie de regarder avec {noms}',
  },
  relecture: {
    question: 'La question posée au panel',
    proposeParLePanel: 'Le vote : ce que le panel a proposé',
    repere: 'Le repère :',
    ajouteeParVous: 'Ajoutée par vous',
    ajouteParVous: 'Ajouté par vous',
    presentation: 'Sa présentation s’écrit.',
    ceQuiSeDit: 'Ce qui se dit :',
    enCeMoment: 'En ce moment :',
    ajouter: 'Ajouter',
    lancerVote: 'Lancer le vote',
    lancerEtude: 'Lancer l’étude',
  },
  cibleParCible: 'Cible par cible',
  duo: {
    titre: 'Chez les 3-7 ans : l’enfant réclame, le parent décide',
    suit: 'Le parent suit son enfant dans {pct} des cas',
    reclame: 'Ce que l’enfant réclame',
    retient: 'Ce que le parent retient',
  },
  envie: '{pct} auraient envie de regarder',
  faceDerniereSaison: ', {pts} face à la dernière saison',
  partProjetee: 'Part d’audience projetée (4 ans et plus)',
  scenarios: '{bas} ~ {haut}',
  repereLegende: '{libelle} : {pct}',
  etape: {
    attente: 'À venir',
    cours: 'En cours',
    relire: 'À relire',
    faite: 'Terminée',
    replier: 'Replier l’étape',
    deplier: 'Déplier l’étape',
  },
  idees: {
    temoignages: 'Les témoignages : {titre}',
  },
  notation: {
    interroger: 'Interroger ceux qui aiment {nom}',
    echelle: 'de 0 à 10',
  },
  citation: '« {texte} »',
  livrable: {
    laQuestion: 'La question',
    seulTerritoire: 'Les résultats du seul territoire {territoire}, parmi ceux interrogés : {liste}.',
    territoiresInterroges: 'Territoire interrogé : {liste}. | Territoire interrogé : {liste}. | Territoires interrogés : {liste}.',
    questionOuverte: 'La question ouverte : « {question} »',
    auVote: 'Au vote',
    ceQuiRevient: 'Ce qui revient',
    reponse: 'Réponse',
    territoireParTerritoire: 'Territoire par territoire',
    noteSur10: 'Note sur 10',
    enTete: 'en tête',
    partProjetee: ' ; part d’audience projetée (4 ans et plus) : {pct}{bornes}',
    faceDerniereSaison: 'Face à la dernière saison',
    repere: 'repère',
  },
}
